import { useMemo } from "react";
import _ from "lodash";

import { colors } from "theme/palette";
import { EMPTY_LIST } from "utils/constants";

import Box from "components/Box";
import SimpleTable from "components/SimpleTable";
import Stack from "components/Stack";
import Text from "components/Text";

import PrintableMemoFieldTitle from "pages/Deal/PrintableMemo/components/PrintableMemoFieldTitle";

import { IPackageDetailsField } from "entities/Checklist/sdk";

interface IPrintableTablefield {
  breakInside?: string;
  field: IPackageDetailsField;
  isNASection: boolean;
}

const PrintableTablefield = ({
  field,
  breakInside = "auto",
  isNASection,
}: IPrintableTablefield) => {
  const value = useMemo(
    () => _.get(field.values, "[0].column_value", EMPTY_LIST),
    [field.values]
  );

  const isNAField = useMemo(
    () => field.n_a_status || isNASection,
    [field, isNASection]
  );

  return (
    <Box>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{
          borderBottom: `1px solid ${colors.blue40}`,
        }}
      >
        <PrintableMemoFieldTitle field={field} disabled={isNAField} />
        <Stack>
          {isNAField && (
            <Text sx={{ opacity: 0.5 }} data-testid="field-value-na">
              N/A
            </Text>
          )}
        </Stack>
      </Stack>
      {!isNAField && (
        <Box
          sx={{
            breakInside,
            paddingTop: 1,
            width: "100%",
          }}
          data-testid="dd-table-field-table"
        >
          <SimpleTable
            headers={
              field.column_name?.split(",").map((column) => ({
                label: column.trim(),
                key: column.trim(),
              })) || []
            }
            rows={value}
            size="small"
            showEmptyRow={true}
            tableDataTestid={field.name}
          />
        </Box>
      )}
    </Box>
  );
};

export default PrintableTablefield;
